/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListinoAnimaliDettaglioCreateDTO,
  ListinoAnimaliDettaglioDTO,
  ListinoAnimaliDettaglioUpdateDTO,
  ListinoCreateDTO,
  ListinoDTO,
  ListinoMangimiDettaglioCreateDTO,
  ListinoMangimiDettaglioDTO,
  ListinoMangimiDettaglioUpdateDTO,
  ListinoPulciniDettaglioCreateDTO,
  ListinoPulciniDettaglioDTO,
  ListinoPulciniDettaglioUpdateDTO,
  ProblemDetails,
} from '../models';
import {
    ListinoAnimaliDettaglioCreateDTOFromJSON,
    ListinoAnimaliDettaglioCreateDTOToJSON,
    ListinoAnimaliDettaglioDTOFromJSON,
    ListinoAnimaliDettaglioDTOToJSON,
    ListinoAnimaliDettaglioUpdateDTOFromJSON,
    ListinoAnimaliDettaglioUpdateDTOToJSON,
    ListinoCreateDTOFromJSON,
    ListinoCreateDTOToJSON,
    ListinoDTOFromJSON,
    ListinoDTOToJSON,
    ListinoMangimiDettaglioCreateDTOFromJSON,
    ListinoMangimiDettaglioCreateDTOToJSON,
    ListinoMangimiDettaglioDTOFromJSON,
    ListinoMangimiDettaglioDTOToJSON,
    ListinoMangimiDettaglioUpdateDTOFromJSON,
    ListinoMangimiDettaglioUpdateDTOToJSON,
    ListinoPulciniDettaglioCreateDTOFromJSON,
    ListinoPulciniDettaglioCreateDTOToJSON,
    ListinoPulciniDettaglioDTOFromJSON,
    ListinoPulciniDettaglioDTOToJSON,
    ListinoPulciniDettaglioUpdateDTOFromJSON,
    ListinoPulciniDettaglioUpdateDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface DeleteListinoAnimaliDettaglioRequest {
    id: number;
}

export interface DeleteListinoMangimiDettaglioRequest {
    id: number;
}

export interface DeleteListinoPulciniDettaglioRequest {
    id: number;
}

export interface GetListiniAnimaliRequest {
    idFiliera?: number;
}

export interface GetListiniAnimaliDettagliRequest {
    idListinoTestata?: number;
    showAll?: boolean;
}

export interface GetListiniMangimiRequest {
    idFiliera?: number;
}

export interface GetListiniMangimiDettagliRequest {
    idListinoTestata?: number;
    showAll?: boolean;
}

export interface GetListiniPulciniRequest {
    idFiliera?: number;
}

export interface GetListiniPulciniDettagliRequest {
    idListinoTestata?: number;
    showAll?: boolean;
}

export interface GetListinoAnimaliByIdRequest {
    idListino?: number;
}

export interface GetListinoAnimaliDettaglioByIdRequest {
    id: number;
}

export interface GetListinoMangimiByIdRequest {
    idListino?: number;
}

export interface GetListinoMangimiDettaglioByIdRequest {
    id: number;
}

export interface GetListinoPulciniByIdRequest {
    idListino?: number;
}

export interface GetListinoPulciniDettaglioByIdRequest {
    id: number;
}

export interface InsertListinoAnimaliRequest {
    listinoCreateDTO?: ListinoCreateDTO;
}

export interface InsertListinoAnimaliDettaglioRequest {
    idListinoTestata?: number;
    listinoAnimaliDettaglioCreateDTO?: ListinoAnimaliDettaglioCreateDTO;
}

export interface InsertListinoMangimiRequest {
    listinoCreateDTO?: ListinoCreateDTO;
}

export interface InsertListinoMangimiDettaglioRequest {
    idListinoTestata?: number;
    listinoMangimiDettaglioCreateDTO?: ListinoMangimiDettaglioCreateDTO;
}

export interface InsertListinoPulciniRequest {
    listinoCreateDTO?: ListinoCreateDTO;
}

export interface InsertListinoPulciniDettaglioRequest {
    idListinoTestata?: number;
    listinoPulciniDettaglioCreateDTO?: ListinoPulciniDettaglioCreateDTO;
}

export interface UpdateListinoAnimaliDettaglioRequest {
    id: number;
    listinoAnimaliDettaglioUpdateDTO?: ListinoAnimaliDettaglioUpdateDTO;
}

export interface UpdateListinoMangimiDettaglioRequest {
    id: number;
    listinoMangimiDettaglioUpdateDTO?: ListinoMangimiDettaglioUpdateDTO;
}

export interface UpdateListinoPulciniDettaglioRequest {
    id: number;
    listinoPulciniDettaglioUpdateDTO?: ListinoPulciniDettaglioUpdateDTO;
}

/**
 * 
 */
export class ListiniApi extends runtime.BaseAPI {

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Elimina un listino animali dettaglio esistente
     */
    async deleteListinoAnimaliDettaglioRaw(requestParameters: DeleteListinoAnimaliDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteListinoAnimaliDettaglio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Animali/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Elimina un listino animali dettaglio esistente
     */
    async deleteListinoAnimaliDettaglio(requestParameters: DeleteListinoAnimaliDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteListinoAnimaliDettaglioRaw(requestParameters, initOverrides);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Elimina un listino mangimi dettaglio esistente
     */
    async deleteListinoMangimiDettaglioRaw(requestParameters: DeleteListinoMangimiDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteListinoMangimiDettaglio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Mangimi/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Elimina un listino mangimi dettaglio esistente
     */
    async deleteListinoMangimiDettaglio(requestParameters: DeleteListinoMangimiDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteListinoMangimiDettaglioRaw(requestParameters, initOverrides);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Elimina un listino pulcini dettaglio esistente
     */
    async deleteListinoPulciniDettaglioRaw(requestParameters: DeleteListinoPulciniDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteListinoPulciniDettaglio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Pulcini/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Elimina un listino pulcini dettaglio esistente
     */
    async deleteListinoPulciniDettaglio(requestParameters: DeleteListinoPulciniDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteListinoPulciniDettaglioRaw(requestParameters, initOverrides);
    }

    /**
     * Elenco di tutti i listini animali
     */
    async getListiniAnimaliRaw(requestParameters: GetListiniAnimaliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListinoDTO>>> {
        const queryParameters: any = {};

        if (requestParameters.idFiliera !== undefined) {
            queryParameters['idFiliera'] = requestParameters.idFiliera;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/ListiniAnimali`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListinoDTOFromJSON));
    }

    /**
     * Elenco di tutti i listini animali
     */
    async getListiniAnimali(requestParameters: GetListiniAnimaliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListinoDTO>> {
        const response = await this.getListiniAnimaliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Elenco di tutti i listini animali dettaglio
     */
    async getListiniAnimaliDettagliRaw(requestParameters: GetListiniAnimaliDettagliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListinoAnimaliDettaglioDTO>>> {
        const queryParameters: any = {};

        if (requestParameters.idListinoTestata !== undefined) {
            queryParameters['idListinoTestata'] = requestParameters.idListinoTestata;
        }

        if (requestParameters.showAll !== undefined) {
            queryParameters['showAll'] = requestParameters.showAll;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Animali`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListinoAnimaliDettaglioDTOFromJSON));
    }

    /**
     * Elenco di tutti i listini animali dettaglio
     */
    async getListiniAnimaliDettagli(requestParameters: GetListiniAnimaliDettagliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListinoAnimaliDettaglioDTO>> {
        const response = await this.getListiniAnimaliDettagliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Elenco di tutti i listini mangimi
     */
    async getListiniMangimiRaw(requestParameters: GetListiniMangimiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListinoDTO>>> {
        const queryParameters: any = {};

        if (requestParameters.idFiliera !== undefined) {
            queryParameters['idFiliera'] = requestParameters.idFiliera;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/ListiniMangimi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListinoDTOFromJSON));
    }

    /**
     * Elenco di tutti i listini mangimi
     */
    async getListiniMangimi(requestParameters: GetListiniMangimiRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListinoDTO>> {
        const response = await this.getListiniMangimiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Elenco di tutti i listini mangimi dettaglio
     */
    async getListiniMangimiDettagliRaw(requestParameters: GetListiniMangimiDettagliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListinoMangimiDettaglioDTO>>> {
        const queryParameters: any = {};

        if (requestParameters.idListinoTestata !== undefined) {
            queryParameters['idListinoTestata'] = requestParameters.idListinoTestata;
        }

        if (requestParameters.showAll !== undefined) {
            queryParameters['showAll'] = requestParameters.showAll;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Mangimi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListinoMangimiDettaglioDTOFromJSON));
    }

    /**
     * Elenco di tutti i listini mangimi dettaglio
     */
    async getListiniMangimiDettagli(requestParameters: GetListiniMangimiDettagliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListinoMangimiDettaglioDTO>> {
        const response = await this.getListiniMangimiDettagliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Elenco di tutti i listini pulcini
     */
    async getListiniPulciniRaw(requestParameters: GetListiniPulciniRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListinoDTO>>> {
        const queryParameters: any = {};

        if (requestParameters.idFiliera !== undefined) {
            queryParameters['idFiliera'] = requestParameters.idFiliera;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/ListiniPulcini`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListinoDTOFromJSON));
    }

    /**
     * Elenco di tutti i listini pulcini
     */
    async getListiniPulcini(requestParameters: GetListiniPulciniRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListinoDTO>> {
        const response = await this.getListiniPulciniRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Elenco di tutti i listini pulcini dettaglio
     */
    async getListiniPulciniDettagliRaw(requestParameters: GetListiniPulciniDettagliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListinoPulciniDettaglioDTO>>> {
        const queryParameters: any = {};

        if (requestParameters.idListinoTestata !== undefined) {
            queryParameters['idListinoTestata'] = requestParameters.idListinoTestata;
        }

        if (requestParameters.showAll !== undefined) {
            queryParameters['showAll'] = requestParameters.showAll;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Pulcini`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListinoPulciniDettaglioDTOFromJSON));
    }

    /**
     * Elenco di tutti i listini pulcini dettaglio
     */
    async getListiniPulciniDettagli(requestParameters: GetListiniPulciniDettagliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListinoPulciniDettaglioDTO>> {
        const response = await this.getListiniPulciniDettagliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recupera un listino animali per id
     */
    async getListinoAnimaliByIdRaw(requestParameters: GetListinoAnimaliByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoDTO>> {
        const queryParameters: any = {};

        if (requestParameters.idListino !== undefined) {
            queryParameters['idListino'] = requestParameters.idListino;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/ListinoAnimaliById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoDTOFromJSON(jsonValue));
    }

    /**
     * Recupera un listino animali per id
     */
    async getListinoAnimaliById(requestParameters: GetListinoAnimaliByIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoDTO> {
        const response = await this.getListinoAnimaliByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recupera un listino animali dettaglio per id
     */
    async getListinoAnimaliDettaglioByIdRaw(requestParameters: GetListinoAnimaliDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoAnimaliDettaglioDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getListinoAnimaliDettaglioById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Animali/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoAnimaliDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Recupera un listino animali dettaglio per id
     */
    async getListinoAnimaliDettaglioById(requestParameters: GetListinoAnimaliDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoAnimaliDettaglioDTO> {
        const response = await this.getListinoAnimaliDettaglioByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recupera un listino mangimi per id
     */
    async getListinoMangimiByIdRaw(requestParameters: GetListinoMangimiByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoDTO>> {
        const queryParameters: any = {};

        if (requestParameters.idListino !== undefined) {
            queryParameters['idListino'] = requestParameters.idListino;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/ListinoMangimiById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoDTOFromJSON(jsonValue));
    }

    /**
     * Recupera un listino mangimi per id
     */
    async getListinoMangimiById(requestParameters: GetListinoMangimiByIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoDTO> {
        const response = await this.getListinoMangimiByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recupera un listino mangimi dettaglio per id
     */
    async getListinoMangimiDettaglioByIdRaw(requestParameters: GetListinoMangimiDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoMangimiDettaglioDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getListinoMangimiDettaglioById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Mangimi/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoMangimiDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Recupera un listino mangimi dettaglio per id
     */
    async getListinoMangimiDettaglioById(requestParameters: GetListinoMangimiDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoMangimiDettaglioDTO> {
        const response = await this.getListinoMangimiDettaglioByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recupera un listino pulcini per id
     */
    async getListinoPulciniByIdRaw(requestParameters: GetListinoPulciniByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoDTO>> {
        const queryParameters: any = {};

        if (requestParameters.idListino !== undefined) {
            queryParameters['idListino'] = requestParameters.idListino;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/ListinoPulciniById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoDTOFromJSON(jsonValue));
    }

    /**
     * Recupera un listino pulcini per id
     */
    async getListinoPulciniById(requestParameters: GetListinoPulciniByIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoDTO> {
        const response = await this.getListinoPulciniByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recupera un listino pulcini dettaglio per id
     */
    async getListinoPulciniDettaglioByIdRaw(requestParameters: GetListinoPulciniDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoPulciniDettaglioDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getListinoPulciniDettaglioById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Pulcini/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoPulciniDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Recupera un listino pulcini dettaglio per id
     */
    async getListinoPulciniDettaglioById(requestParameters: GetListinoPulciniDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoPulciniDettaglioDTO> {
        const response = await this.getListinoPulciniDettaglioByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino animali in anagrafica
     */
    async insertListinoAnimaliRaw(requestParameters: InsertListinoAnimaliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/InsertListinoAnimali`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoCreateDTOToJSON(requestParameters.listinoCreateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoDTOFromJSON(jsonValue));
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino animali in anagrafica
     */
    async insertListinoAnimali(requestParameters: InsertListinoAnimaliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoDTO> {
        const response = await this.insertListinoAnimaliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino animali dettaglio in anagrafica
     */
    async insertListinoAnimaliDettaglioRaw(requestParameters: InsertListinoAnimaliDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoAnimaliDettaglioDTO>> {
        const queryParameters: any = {};

        if (requestParameters.idListinoTestata !== undefined) {
            queryParameters['idListinoTestata'] = requestParameters.idListinoTestata;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Animali`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoAnimaliDettaglioCreateDTOToJSON(requestParameters.listinoAnimaliDettaglioCreateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoAnimaliDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino animali dettaglio in anagrafica
     */
    async insertListinoAnimaliDettaglio(requestParameters: InsertListinoAnimaliDettaglioRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoAnimaliDettaglioDTO> {
        const response = await this.insertListinoAnimaliDettaglioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino mangimi in anagrafica
     */
    async insertListinoMangimiRaw(requestParameters: InsertListinoMangimiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/InsertListinoMangimi`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoCreateDTOToJSON(requestParameters.listinoCreateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoDTOFromJSON(jsonValue));
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino mangimi in anagrafica
     */
    async insertListinoMangimi(requestParameters: InsertListinoMangimiRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoDTO> {
        const response = await this.insertListinoMangimiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino mangimi dettaglio in anagrafica
     */
    async insertListinoMangimiDettaglioRaw(requestParameters: InsertListinoMangimiDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoMangimiDettaglioDTO>> {
        const queryParameters: any = {};

        if (requestParameters.idListinoTestata !== undefined) {
            queryParameters['idListinoTestata'] = requestParameters.idListinoTestata;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Mangimi`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoMangimiDettaglioCreateDTOToJSON(requestParameters.listinoMangimiDettaglioCreateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoMangimiDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino mangimi dettaglio in anagrafica
     */
    async insertListinoMangimiDettaglio(requestParameters: InsertListinoMangimiDettaglioRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoMangimiDettaglioDTO> {
        const response = await this.insertListinoMangimiDettaglioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino pulcini in anagrafica
     */
    async insertListinoPulciniRaw(requestParameters: InsertListinoPulciniRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/InsertListinoPulcini`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoCreateDTOToJSON(requestParameters.listinoCreateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoDTOFromJSON(jsonValue));
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino pulcini in anagrafica
     */
    async insertListinoPulcini(requestParameters: InsertListinoPulciniRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoDTO> {
        const response = await this.insertListinoPulciniRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino pulcini dettaglio in anagrafica
     */
    async insertListinoPulciniDettaglioRaw(requestParameters: InsertListinoPulciniDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListinoPulciniDettaglioDTO>> {
        const queryParameters: any = {};

        if (requestParameters.idListinoTestata !== undefined) {
            queryParameters['idListinoTestata'] = requestParameters.idListinoTestata;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Pulcini`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoPulciniDettaglioCreateDTOToJSON(requestParameters.listinoPulciniDettaglioCreateDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListinoPulciniDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Crea un nuovo listino pulcini dettaglio in anagrafica
     */
    async insertListinoPulciniDettaglio(requestParameters: InsertListinoPulciniDettaglioRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListinoPulciniDettaglioDTO> {
        const response = await this.insertListinoPulciniDettaglioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Aggiorna un listino animali dettaglio esistente
     */
    async updateListinoAnimaliDettaglioRaw(requestParameters: UpdateListinoAnimaliDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateListinoAnimaliDettaglio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Animali/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoAnimaliDettaglioUpdateDTOToJSON(requestParameters.listinoAnimaliDettaglioUpdateDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Aggiorna un listino animali dettaglio esistente
     */
    async updateListinoAnimaliDettaglio(requestParameters: UpdateListinoAnimaliDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateListinoAnimaliDettaglioRaw(requestParameters, initOverrides);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Aggiorna un listino mangimi dettaglio esistente
     */
    async updateListinoMangimiDettaglioRaw(requestParameters: UpdateListinoMangimiDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateListinoMangimiDettaglio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Mangimi/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoMangimiDettaglioUpdateDTOToJSON(requestParameters.listinoMangimiDettaglioUpdateDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Aggiorna un listino mangimi dettaglio esistente
     */
    async updateListinoMangimiDettaglio(requestParameters: UpdateListinoMangimiDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateListinoMangimiDettaglioRaw(requestParameters, initOverrides);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Aggiorna un listino pulcini dettaglio esistente
     */
    async updateListinoPulciniDettaglioRaw(requestParameters: UpdateListinoPulciniDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateListinoPulciniDettaglio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["https://api.gestionale.avigel.it/access_as_user"]);
        }

        const response = await this.request({
            path: `/Filiere/Listini/Pulcini/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ListinoPulciniDettaglioUpdateDTOToJSON(requestParameters.listinoPulciniDettaglioUpdateDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permessi richiesti:<ul><li>Tabelle/Write </li></ul>
     * Aggiorna un listino pulcini dettaglio esistente
     */
    async updateListinoPulciniDettaglio(requestParameters: UpdateListinoPulciniDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateListinoPulciniDettaglioRaw(requestParameters, initOverrides);
    }

}
